import $ from "jquery";

$('#js-hamburger').on('click', (event) => {
  $(event.currentTarget).toggleClass('-active');
  $('#js-globalNav').slideToggle();
  return false;
});
